import { env } from '@/shared/config'

type RequestOptions = {
    url: string
    method: 'GET' | 'POST' | 'PUT' | 'DELETE'
    data?: unknown
    apiUrl?: string
}

let serverBaseMs = 0
let perfBaseMs = 0

export function getServerNowMs() {
    return serverBaseMs + (performance.now() - perfBaseMs)
}

export async function createRequest(options: RequestOptions) {
    try {
        const { url, method, data, apiUrl = env.API_DOMAIN } = options

        if (!apiUrl)
            return Promise.resolve({
                data: {},
                status: 200,
                serverTime: new Date().getTime(),
            })
        const requestTimeStart = performance.now()
        const response = await fetch(`${apiUrl ?? ''}/api/${url}`, {
            method,
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        const requestTimeEnd = performance.now()

        const date = response.headers.get('date')

        const serverTime = date
            ? new Date(date).getTime()
            : new Date().getTime()

        const requestTime = requestTimeEnd - requestTimeStart

        if (!response.ok) {
            throw new Error(response.status.toString())
        }

        const d = await response.json()

        if (!serverBaseMs) {
            serverBaseMs = serverTime + requestTime / 2
            perfBaseMs = requestTimeEnd
        }

        return Promise.resolve({
            data: d,
            status: response.status,
            serverTime: getServerNowMs(),
        })
    } catch (e) {
        throw new Error(e as string)
    }
}
